/**
 * The page that signs one order's TRF.
 *
 * Callers leave with a full document load (``window.location.assign``), never a
 * client-side navigate: the ceremony frame needs the headers CloudFront serves
 * under ``/sign*``, and a route change keeps whatever the current document got.
 */
export function trfSigningPath(orderId: string): string {
  return `/sign/${encodeURIComponent(orderId)}`
}

/** Whether ``path`` is under ``/sign`` and so must be entered by a full document load. */
export function isTrfSigningPath(path: string): boolean {
  return /^\/sign(?:[/?#]|$)/.test(path)
}
